'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isList = isList;
exports.getListMarkup = getListMarkup;

var _block = require('./block');

/**
* Function to check if a block is of type list.
*/
function isList(blockType) {
    return blockType === 'unordered-list-item' || blockType === 'ordered-list-item';
}

/**
* Function will return html markup for a list block.
*/
function getListMarkup(listBlocks, entityMap, hashtagConfig, directional, customEntityTransform) {
    var listHtml = [];
    var nestedListBlock = [];
    var previousBlock = void 0;
    listBlocks.forEach(function (block) {
        var nestedBlock = false;
        if (!previousBlock) {
            listHtml.push('<' + (0, _block.getBlockTag)(block.type) + '>\n');
        } else if (previousBlock.type !== block.type) {
            listHtml.push('</' + (0, _block.getBlockTag)(previousBlock.type) + '>\n');
            listHtml.push('<' + (0, _block.getBlockTag)(block.type) + '>\n');
        } else if (previousBlock.depth === block.depth) {
            if (nestedListBlock && nestedListBlock.length > 0) {
                listHtml.push(getListMarkup(nestedListBlock, entityMap, hashtagConfig, directional, customEntityTransform));
                nestedListBlock = [];
            }
        } else {
            nestedBlock = true;
            nestedListBlock.push(block);
        }
        if (!nestedBlock) {
            listHtml.push('<li');
            var blockStyle = (0, _block.getBlockStyle)(block.data);
            if (blockStyle) {
                listHtml.push(' style="' + blockStyle + '"');
            }
            if (directional) {
                listHtml.push(' dir = "auto"');
            }
            listHtml.push('>');
            listHtml.push((0, _block.getBlockInnerMarkup)(block, entityMap, hashtagConfig, customEntityTransform));
            listHtml.push('</li>\n');
            previousBlock = block;
        }
    });
    if (nestedListBlock && nestedListBlock.length > 0) {
        listHtml.push(getListMarkup(nestedListBlock, entityMap, hashtagConfig, directional, customEntityTransform));
    }
    listHtml.push('</' + (0, _block.getBlockTag)(previousBlock.type) + '>\n');
    return listHtml.join('');
}


//////////////////
// WEBPACK FOOTER
// ./js/src/utils/draftToHTML/list.js
// module id = 111
// module chunks = 0